// 路由拦截
import router from "."
router.beforeEach((to, from, next) => {
  // 判断是否需要登录，并且是否登录
  if (to.meta.needLogin && !sessionStorage.getItem('getToken')) {
    return next('/login')
  } else {
    next()
  }
})